
define('ProductInventoryByLocation.Model',
    [
        'Backbone',
        'underscore',
        'Utils'
    ],
      function (
        Backbone,
        _,
        Utils
    ) {
        'use strict';
        return Backbone.Model.extend({
            urlRoot: Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/ProductInventoryByLocation.Service.ss"
                )
            ),
        });
    });
